import React from "react";
import icons from "../../../assets/icons/icons";
import "./email-setup-banner.scss";

const EmailSetUpBanner = () => {
  return (
    <div className="email-setup-banner">
      <img src={icons.TermOfServicesInfo} alt="info icon" />
      <p className="email-setup-text">
        <strong>Email Setup Required:</strong> Please configure your company
        email account under Company Settings to enable email-related features
        such as exporting or downloading reports and other data.
      </p>
    </div>
  );
};

export default EmailSetUpBanner;